/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */
import styled, { keyframes } from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const SuperSearchListContainerStyled = styled.div.attrs({
    className: 'super-search__list',
})`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 50vh;
    box-sizing: border-box;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    background-color: ${colors.superSearchBgColor};
    z-index: 200;
    & > div:first-child {
        padding-top: 8px;
    }
    & > div:last-child {
        padding-bottom: 16px
    }
    & .super-search__item-text_bold {
        font-weight: bold;
        background-color: unset;
    }
    & .group__item-secondary .super-search__item-text_bold {
        color: ${colors.superSearchTextSecondary};
    }

`;
export const SuperSearchListGroupStyled = styled.div.attrs({
    className: 'super-search__group',
})`
`;
export const SuperSearchListGroupTitleStyled = styled.div.attrs({
    className: 'super-search__group-title',
})`
    padding: 16px 0 0 32px;
    ${fonts.textSmall};
    color: ${colors.superSearchText};
    text-transform: uppercase;
    letter-spacing: 1.2px;
`;
export const SuperSearchListItem = styled.div.attrs({
    className: 'super-search__group group__item',
    tabIndex: 0,
})`
    padding: 8px 0 8px 32px;
    cursor: pointer;
    &:focus,
    &:hover {
        background-color: ${colors.superSearchBgHoverColor};
        outline: none;
    }
`;
export const SuperSearchListItemTitle = styled.div.attrs({
    className: 'super-search__group group__item-title',
})`
    ${fonts.textMain}
    line-height: 1.6;
`;
export const SuperSearchListItemSecondary = styled.div.attrs({
    className: 'super-search__group group__item-secondary',
})`
    ${fonts.textSmall};
    color: ${colors.superSearchTextSecondary};
`;
export const SuperSearchListItemStub = styled.div.attrs({
    className: 'super-search__group group__item',
})`
    display: flex;
    padding: 8px 0 8px 32px;
    &: {
        ${fonts.textMain};
    }
    color: ${colors.superSearchTextSecondary};
    & > span {
        margin-left: 24px;
    }
`;

const bigLoaderShimmer = keyframes`
    0% {
        background-position: -100px;
    }
    100% {
        background-position: 364px;
    }
`;
const smallLoaderShimmer = keyframes`
    0% {
        background-position: -80px;
    }
    50%, 100% {
        background-position: 172px;
    }
`;
const LoaderAnimation = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    backface-visibility: hidden;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    background: white;
    background: ${colors.superSearchBgLoader};
`;
export const SuperSearchBigLoaderStyled = styled(LoaderAnimation)`
    width: 464px;
    animation-name: ${bigLoaderShimmer};
    animation-duration: 5s;
`;
export const SuperSearchSmallLoaderStyled = styled(LoaderAnimation)`
    width: 232px;
    animation-name: ${smallLoaderShimmer};
    animation-duration: 5s;
`;
export const SuperSearchLoaderStubBigStyled = styled.div.attrs({
    className: 'super-search__group group__item-loader',
})`
    position: relative;
    max-width: 464px;
    height: 12px;
    margin: 8px 0 8px 32px;
`;
export const SuperSearchLoaderStubSmallStyled = styled.div.attrs({
    className: 'super-search__group group__item-loader',
})`
    position: relative;
    max-width: 232px;
    height: 12px;
    margin-left: 32px;
`;
